// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ujD2","content":"styles_content__1uEv_","tableWrap":"styles_tableWrap__LoZVK"};